import React, { useContext } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "@stripe/stripe-js";

import { Home } from "./pages/Home";
import SubscriptionPrompt from "./components/SubscriptionPrompt";
import PageTracker from "./context/PageTracker";
import "./App.css";
import UploadCV from "./components/UploadCV";
import InitialLoadingScreen from "./components/InitialLoadingScreen";
import PrivacyPolicy from "./components/PrivacyPolicy";

function App() {
  return (
    <div>
      {/* <SubscriptionPrompt /> */}
      <Router>
        <PageTracker />
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route exact path="/cvUpload" element={<UploadCV />} />
          <Route exact path="/initialLoading" element={<InitialLoadingScreen />} />
          <Route exact path="/privacypolicy" element={<PrivacyPolicy />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
